import "../styles/view-reservations.css"; 
import { useTranslation } from "react-i18next";
import { useEffect, useRef, useState } from "react";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { PrimeIcons } from "primereact/api";
import BookingController from "../services/booking-controller";
import { getToken, toPersian10DigitDate } from "../utility";

export default function ViewReservations() {
	const { t } = useTranslation();
	const localizer = t;
	const bookingController = new BookingController();
	const toast = useRef(null);
	const [isLoading, setIsLoading] = useState(false);
	//
	const [isSaving, setIsSaving] = useState(false);
	const [pageType, setPageType] = useState("list");
	const [searchStatus, setSearchStatus] = useState("");
	//
	const [reservations, setReservations] = useState([]);
	const [reservation, setReservation] = useState({ items: [] });
	//> useEffect
	useEffect(() => {
		getData();
	}, [searchStatus]);
	//> getData
	const getData = async function () {
		try {
			setIsLoading(true);

			const reservationsResult = await bookingController.getReservations();
			if (reservationsResult.isSuccess === false)
				throw reservationsResult.message;
			setReservations(reservationsResult.value);
		} catch (error) {
			alert(error.toString());
		}
		setIsLoading(false);
	};
	//> changeSearchStatus
	const changeSearchStatus = function (status) {
		setSearchStatus(status);
	};

	//> viewReservation
	const viewReservation = async function (objReservation) {
		try {
			setPageType("view");
			const reservationResult = await bookingController.getReservation(
				objReservation.code
			);
			if (reservationResult.isSuccess === false)
				throw reservationResult.message;
			setReservation(reservationResult.value);
		} catch (error) {
			alert(error.toString());
		}
	};
	//> cancelReservation
	const cancelReservation = async function () {
		try {
			let errors = [];
			if (errors.length > 0) {
				errors.map((item) => {
					toast.current.show({
						severity: "warn",
						summary: "درخواست کنسل کردن اقامتگاه",
						detail: item,
					});
				});
				return;
			}
			//
			setIsSaving(true);
			var cancelRervationResult = await bookingController.cancelReservation(
				reservation.code
			);
			if (cancelRervationResult.isSuccess === false)
				throw cancelRervationResult.message;

			toast.current.show({
				severity: "success",
				summary: "کنسل کردن اقامتگاه",
				detail: localizer("تغییر کنسل کردن اقامتگاه با موفقیت ثبت شد"),
			});
			setPageType("list");
			getData();
		} catch (error) {
			alert(error.toString());
		}
		setIsSaving(false);
	};
	//> cancelreservation
	const cancelreservation = function () {
		setPageType("list");
	};

	//>
	if (!getToken()) {
		window.location = "/#/login";
		return;
	}
	return (
		<>
			<Toast ref={toast} position="bottom-left" life={1500} />
			<article className="reservations">
				{pageType === "list" && (
					<>
						<ul className="status">
							<li
								className={searchStatus === "" ? "active" : ""}
								onClick={() => changeSearchStatus("")}
							>
								همه
							</li>
							<li
								className={searchStatus === "Wait" ? "active wait" : "wait"}
								onClick={() => changeSearchStatus("Wait")}
							>
								منتظر پرداخت
							</li>
							<li
								className={searchStatus === "Payed" ? "active payed" : "payed"}
								onClick={() => changeSearchStatus("Payed")}
							>
								پرداخت شده
							</li>
							<li
								className={searchStatus === "InUse" ? "active inuse" : "inuse"}
								onClick={() => changeSearchStatus("InUse")}
							>
								در حال استفاده
							</li>
							<li
								className={
									searchStatus === "Complete" ? "active complete" : "complete"
								}
								onClick={() => changeSearchStatus("Complete")}
							>
								تکمیل شده
							</li>
							<li
								className={
									searchStatus === "Cancel" ? "active cancel" : "cancel"
								}
								onClick={() => changeSearchStatus("Cancel")}
							>
								کنسل شده
							</li>
						</ul>
						<table>
							<thead>
								<tr>
									<th>#</th>
									<th>کد رزرو</th>
									<th>تاریخ شروع</th>
									<th>مدت اقامت</th>
									<th>هزینه اقامتگاه</th>
									<th>وضعیت</th>
									<th>کد پیگیری</th>
									<th>تاریخ درخواست</th>
								</tr>
							</thead>
							<tbody>
								{reservations.map((item) => (
									<tr data-status={item.status}>
										<td>{item.index}</td>
										<td>
											<a
												href="javascript:void(0);"
												onClick={() => viewReservation(item)}
											>
												{item.code}
											</a>
										</td>
										<td>{toPersian10DigitDate(item.startDate)}</td>
										<td>{item.totalDays} شب</td>
										<td>{item.totalAmount.toLocaleString("en-US")}</td>
										<td>{item.status}</td>
										<td>{item.trackingNumber}</td>
										<td>{toPersian10DigitDate(item.createdOn)}</td>
									</tr>
								))}
							</tbody>
						</table>
					</>
				)}

				{pageType === "view" && (
					<div class="cb-success">
						<h2>جزییات رزرو اقامتگاه</h2>
						<ul class="r-details">
							<li>
								<label>کد رزرو</label>
								<i></i>
								<b>{reservation.code}</b>
							</li>
							<li>
								<label>شماره پیگیری</label>
								<i></i>
								<b>{reservation.trackingNumber}</b>
							</li>
							<li>
								<label>تاریخ پرداخت</label>
								<i></i>
								<b>
									{new Date(reservation.paymentDate)
										?.toLocaleString("fa-IR")
										.replace(",", " ساعت ")}
								</b>
							</li>
							<li>
								<label>هزینه قبل از تخفیف</label>
								<i></i>
								<b>
									{reservation.totalAmounWithoutDiscount?.toLocaleString(
										"en-US"
									)}{" "}
									ریال
								</b>
							</li>
							<li>
								<label>تخفیف</label>
								<i></i>
								<b>{reservation.discount?.toLocaleString("en-US")} ریال</b>
							</li>
							<li>
								<label>مبلغ کوپن تخفیف</label>
								<i></i>
								<b>
									{reservation.couponDiscount?.toLocaleString("en-US")} ریال
								</b>
							</li>
							<li>
								<label>هزینه پرداختی</label>
								<i></i>
								<b>{reservation.totalAmount?.toLocaleString("en-US")} ریال</b>
							</li>
						</ul>
						{reservation.items.map((item) => (
							<div>
								<h2>{item.notes}</h2>
								<div class="item-info">
									<span>{toPersian10DigitDate(item.reserveDate)}</span>
									<b>{item.quantity} نفر</b>
								</div>
								<div class="price">
									<span>{item.unitCost.toLocaleString("en-US")}</span>
									<b>با {item.discount.toLocaleString("en-US")} ریال تخفیف</b>
									<strong>
										{item.totalAmount.toLocaleString("en-US")} ریال
									</strong>
								</div>
							</div>
						))}

						<div className="buttons">
							<Button
								label="درخواست کنسلی"
								onClick={() => cancelReservation()}
								severity="success"
								icon={PrimeIcons.SAVE}
								loading={isSaving}
							/>
							<Button
								label="بازگشت"
								onClick={() => setPageType("list")}
								severity="default"
								loading={isSaving}
							/>
						</div>
					</div>
				)}
			</article>
		</>
	);
}
